import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c4.77 0 7.939.671 9.565 2.152l.147.141 3.996 4a1 1 0 0 1 .283.576L26 10v.999L27 11a1 1 0 0 1 .5.134l.108.072.1.087 2 2a1 1 0 0 1 .082 1.32l-.083.094-5 5a1 1 0 0 1-1.32.083l-.094-.083-2-2a1 1 0 0 1-.284-.576L21 17v-1.001l-.575.001L9.224 27.698l-.123.144-.13.137a3.5 3.5 0 0 1-5.085-4.807l.146-.154.102-.097.106-.09 11.818-11.313c.458-3.555-.842-5.247-4.141-5.521a1 1 0 0 1-.91-.879L11 5V4a1 1 0 0 1 1-1m4.984 10.399L5.559 24.332q-.06.048-.117.104a1.5 1.5 0 0 0 2.007 2.225l.133-.122.141-.16L18.6 15.014zm-.969-8.06-.199-.145.163.02.353.046c1.965.279 3.292.773 3.965 1.447L24 10.414V12l.007.117.02.112A1 1 0 0 0 25 13l1.584-.001L27.585 14 24 17.585l-1-1V15l-.007-.117-.02-.112A1 1 0 0 0 22 14l-1.586-.001-2.358-2.358.04-.37c.236-2.7-.475-4.71-2.081-5.933"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSubsVendors = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSubsVendors);
export default Memo;
